import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

type Props = {
  text: string;
};

const PlainHomeButton = (props: Props) => {
  const { text } = props;
  return (
    <Styled>
      <Link to="/">{text}</Link>
    </Styled>
  );
};

PlainHomeButton.defaultProps = {
  text: 'トップページに戻る',
};

const Styled = styled.div`
  font-size: 14px;
  color: #6a6a6a;
  text-decoration: underline;
  text-align: center;
  width: 100%;

  a {
    &:visited {
      color: #6a6a6a;
    }
  }
`;

export default PlainHomeButton;
